import React, {useState, useEffect, useContext, useLayoutEffect} from 'react'
import {json, useNavigate} from 'react-router-dom'
import { Passaggio } from "../App"
import Swal from 'sweetalert2';
import '../Citta/Citta.css'

const Citta = () => {
    const [citta, setcitta] = useState([])
    const { url } = useContext(Passaggio);
    const link=useNavigate() //UseNavigate per passare da un componente all'altro

    useLayoutEffect(() => {
        setcitta([]);
        ScaricaCitta();
        controllaToken();
    }, [])

const controllaToken=()=>{


    fetch(url+ "/contolloToken",{
        method: 'POST',
        headers: {
            'Accept':'application/json',
            'Content-Type':'application/json',
            'Authorization':"Bearer " + sessionStorage.getItem("token")
        }
    })
.then(response => response.json())
.then((dati)=>{
    if(dati.risultato=="ko" || dati.risultato==undefined){
        Swal.fire({ title: 'Login fallito. Riprova.', icon: 'warning', timer: 1500, showConfirmButton: false });
         link("/")
    }
    
})
}

    const passaLocali=(p)=>{
        //Salvo in sessionStorage l'ID della città
        sessionStorage.setItem('idCitta', p)
        //Passo alla pagina dei locali
        link("/locali")
    }

    //Funzione fetch per scaricare città, inserisco le info nel vettore "vettoreCitta"
    //Setto lo stato con il vettore appena riempito
    const ScaricaCitta=()=>{
        
        fetch(url+"/getCitta")
        .then(response=>response.json())
        .then(data=>{
            setcitta(data)
        })
    }

    useEffect(() => {
        ScaricaCitta()
    }, [])
    //visualizzo le citta nel return
    return (
    <div className="cittaPage">
        <div className="log">
            <div className="contenitoreCitta">
                
                <div className="headingsContainer">
                    <h1 className="mangiuma-elegant">SCEGLI LA CITTÀ</h1>
                    <h2 className='color'>Dove vuoi ordinare oggi?</h2>
                </div>

                <div className="mainContainer cittaContainer">
                    
                    {citta.map(element => (
                        <div 
                            key={element.id_c} 
                            className='pulsante'
                            onClick={() => passaLocali(element.id_c)}
                        >
                            <div className='formattatesto'>
                                {element.nome}
                            </div>
                            <img 
                                className='stemma' 
                                src={element.stemma}
                                alt="stemma"
                            />
                        </div>
                    ))}
                </div>

            </div>
        </div>
    </div>
)
}
export default Citta